<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <div class="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 class="h6 mb-0 text-gray-800">Início</h1>
        </div>
        <div class="row" v-if="number_activities_overdue > 0">
            <div class="col-xl-12 col-md-12 col-sm-12 mb-4">
                <div class="jumbotron border-left-danger">
                    <h1 class="display-4">Olá, {{ name_user }}!</h1>
                    <p class="lead">Há {{ number_activities_overdue }} atividade(s) no sistema em atraso.</p>
                    <hr class="my-4">

                    <p class="lead">
                        <router-link to="/activity" class="btn btn-primary btn-lg" href="#" role="button">Ver minhas
                            atividades</router-link>
                    </p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-3 col-md-6 mb-4">
                <quantitativeData color="border-left-success" nameCard="Clientes ativos" :number="client_active"
                    icon="fa-check"></quantitativeData>
            </div>
            <div class="col-xl-3 col-md-6 mb-4">
                <quantitativeData color="border-left-danger" nameCard="Leads pendentes" :number="lead_pending"
                    icon="fa-spinner">
                </quantitativeData>
            </div>

            <!-- Earnings (Monthly) Card Example -->
            <div class="col-xl-3 col-md-6 mb-4">
                <quantitativeData color="border-left-primary" nameCard="Leads ativos" :number="lead_active"
                    icon="fa fa-thumbs-up"></quantitativeData>
            </div>

            <!-- Pending Requests Card Example -->
            <div class="col-xl-3 col-md-6 mb-4">
                <quantitativeData color="border-left-warning" nameCard="Leads desistentes" :number="lead_give_up"
                    icon="fa fa-thumbs-down"></quantitativeData>
            </div>
        </div>
        <div class="row mb-5"></div>
        <div class="row mb-5">
            <div class="col-xl-6 col-md-6 col-sm-12">
                <GraphLead></GraphLead>
            </div>
            <div class="col-xl-6 col-md-6 col-sm-12">
                <GraphClient></GraphClient>
            </div>
        </div>
        <div class="row mb-5"></div>
    </div>
</template>

<script>

import api from '@/api';
import quantitativeData from '@/components/dashboard/quantitative-data.vue'
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import GraphLead from '@/components/dashboard/graph-lead.vue'
import GraphClient from '@/components/dashboard/graph-client.vue'

export default {
    components: { Loading, quantitativeData, GraphLead, GraphClient },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            client_active: 'Carregando',
            lead_pending: 'Carregando',
            lead_active: 'Carregando',
            lead_give_up: 'Carregando',
            year_client: 2026,
            number_activities_overdue: 0,
            name_user: ''
        }
    },
    mounted() {
        this.name_user = localStorage.getItem('name');
        this.loadData();
        this.loadDataActivities();
        this.checkVersion();
    },
    methods: {
        onCancel() { },
        loadData() {
            console.clear();
            this.isLoading = true;
            api.get('/dashboard/listDataClient')
                .then((response) => {
                    this.isLoading = false;
                    this.client_active = response.data.data.total_client_active;
                    this.lead_pending = response.data.data.total_lead_pending;
                    this.lead_active = response.data.data.total_lead_active;
                    this.lead_give_up = response.data.data.total_lead_give_up;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },
        loadDataActivities() {
            console.clear();
            this.isLoading = true;
            api.get('/activity/statusOverdue')
                .then((response) => {
                    this.isLoading = false;
                    this.number_activities_overdue = response.data.quantity;

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },
        checkVersion() {
            let version_storage = localStorage.getItem('version_storage');
            let version_env = process.env.VUE_APP_VERSION;
            if (version_storage == undefined || version_storage == null || version_storage == '') {
                localStorage.setItem('version_storage', version_env);
                window.location.reload(true);
            } else {
                if (version_storage != version_env) {
                    if (confirm('Uma nova versão está disponível. Clique em ok para atualizar, por favor.')) {
                        localStorage.setItem('version_storage', version_env);
                        window.location.reload(true);
                    }
                }
            }
        }

    }
}
</script>

<style>
.select-graph {
    width: 25% !important;
    float: right;
}
</style>